export const LIST_JOB_TITLE_REQUEST = 'LIST_JOB_TITLE_REQUEST'
export const LIST_JOB_TITLE_SUCCESS = 'LIST_JOB_TITLE_SUCCESS'
export const LIST_JOB_TITLE_FAIL = 'LIST_JOB_TITLE_FAIL'

export const LIST_JOB_TITLE_SUMMARY_REQUEST = 'LIST_JOB_TITLE_SUMMARY_REQUEST'
export const LIST_JOB_TITLE_SUMMARY_SUCCESS = 'LIST_JOB_TITLE_SUMMARY_SUCCESS'
export const LIST_JOB_TITLE_SUMMARY_FAIL = 'LIST_JOB_TITLE_SUMMARY_FAIL'

export const CREATE_JOB_TITLE_REQUEST = 'CREATE_JOB_TITLE_REQUEST'
export const CREATE_JOB_TITLE_SUCCESS = 'CREATE_JOB_TITLE_SUCCESS'
export const CREATE_JOB_TITLE_FAIL = 'CREATE_JOB_TITLE_FAIL'

export const DETAIL_JOB_TITLE_REQUEST = 'DETAIL_JOB_TITLE_REQUEST'
export const DETAIL_JOB_TITLE_SUCCESS = 'DETAIL_JOB_TITLE_SUCCESS'
export const DETAIL_JOB_TITLE_FAIL = 'DETAIL_JOB_TITLE_FAIL'

export const UPDATE_JOB_TITLE_REQUEST = 'UPDATE_JOB_TITLE_REQUEST'
export const UPDATE_JOB_TITLE_SUCCESS = 'UPDATE_JOB_TITLE_SUCCESS'
export const UPDATE_JOB_TITLE_FAIL = 'UPDATE_JOB_TITLE_FAIL'

export const DELETE_JOB_TITLE_REQUEST = 'DELETE_JOB_TITLE_REQUEST'
export const DELETE_JOB_TITLE_SUCCESS = 'DELETE_JOB_TITLE_SUCCESS'
export const DELETE_JOB_TITLE_FAIL = 'DELETE_JOB_TITLE_FAIL'
